import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";
import { useAuth } from "@/context/AuthContext";

function Block({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="text-[20px] font-bold tracking-tight text-ink">{title}</h2>
            <div className="mt-3 space-y-3 measure text-[16px] leading-[1.6] text-subtle">{children}</div>
        </section>
    );
}

export default function Privacy() {
    const { settings } = useAuth();
    const updated = settings?.privacy_updated || "junio de 2026";
    const contact = settings?.contact_email;

    return (
        <div className="min-h-screen bg-background">
            <header className="border-b border-line bg-background">
                <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
                    <Brand />
                    <Link to="/" className="text-[14px] text-subtle hover:text-ink">Volver al inicio</Link>
                </div>
            </header>

            <main className="mx-auto max-w-3xl px-6 py-16">
                <h1 className="text-[34px] font-bold leading-[1.1] tracking-[-0.02em] text-ink lg:text-[44px]">
                    Privacidad y datos
                </h1>
                <p className="mt-3 text-[14px] text-subtle">Última actualización: {updated}</p>

                <Block title="Responsable del tratamiento">
                    <p>
                        La responsable del tratamiento de tus datos es <strong className="text-ink">Olga García Estévez</strong>
                        {" "}(DNI 08035475B), con domicilio en Calle Polvoranca 70, escalera 2, 8C, 28923 Alcorcón (Madrid).
                        Para cualquier cuestión sobre tus datos puedes escribir a{" "}
                        <a href="mailto:garciaestevezolga@gmail.com" className="text-terracotta hover:underline">garciaestevezolga@gmail.com</a>.
                    </p>
                </Block>

                <Block title="Quiénes somos">
                    <p>
                        MYAVEREN es una herramienta para cuidar la piel con criterio. Tratamos tus datos con el
                        mínimo necesario para que funcione, nada más.
                    </p>
                </Block>

                <Block title="Qué datos guardamos y para qué">
                    <p>Guardamos solo lo que hace falta para darte tu análisis y tu rutina:</p>
                    <ul className="list-disc space-y-1 pl-5">
                        <li><strong className="text-ink">Tu cuenta</strong>: nombre y correo, para identificarte y avisarte. La contraseña se guarda cifrada; nadie, ni nosotros, puede leerla.</li>
                        <li><strong className="text-ink">Tu piel</strong>: las respuestas del cuestionario y las puntuaciones que calculamos, para armar tu rutina y medir tu evolución.</li>
                        <li><strong className="text-ink">Tu neceser</strong>: los productos que añades, para saber qué tienes y qué te falta.</li>
                        <li><strong className="text-ink">Las fotos</strong>, si decides subirlas: se usan solo para el análisis en el momento y no las publicamos ni las cedemos.</li>
                    </ul>
                </Block>

                <Block title="Durante cuánto tiempo">
                    <p>
                        Mantenemos tus datos mientras tengas la cuenta activa. Si pides borrarla, eliminamos tu
                        perfil y todo lo asociado. Puedes hacerlo tú desde <strong className="text-ink">Ajustes → Eliminar mi cuenta</strong>.
                    </p>
                </Block>

                <Block title="Con quién los compartimos">
                    <p>
                        No vendemos ni cedemos tus datos a terceros con fines comerciales. Para que la
                        herramienta funcione usamos proveedores técnicos (alojamiento, envío de correos y, si
                        subes fotos, un servicio de análisis de imagen), que tratan los datos por cuenta nuestra
                        y solo para prestar el servicio.
                    </p>
                </Block>

                <Block title="Tus derechos">
                    <p>
                        Puedes acceder a tus datos, corregirlos o pedir que los borremos en cualquier momento.
                        La forma más rápida es desde tu cuenta{contact ? ", o escribiéndonos a " : "."}
                        {contact && <a href={`mailto:${contact}`} className="text-terracotta hover:underline">{contact}</a>}
                    </p>
                </Block>

                <Block title="Aviso importante">
                    <p>
                        MYAVEREN ofrece orientación cosmética, no consejo médico. Ante un problema de piel que te
                        preocupe, consulta con un dermatólogo.
                    </p>
                </Block>
            </main>

            <SiteFooter />
        </div>
    );
}
